import React from 'react';
import { useState } from "react";
import CloseFillIcon from 'remixicon-react/CloseFillIcon';

export default function CloseButton(props) {
    const [isHover, setIsHover] = useState(false);

    const wrapper ={
        width:40,
        height:40,
        borderRadius:'50%',
        backgroundColor: isHover ? 'rgba(192,192,192,0.5)' : 'transparent',
    };

    const icon = {
        marginTop:4,
        marginLeft:4,
        color:'rgb(128,128,128)',
        marginRight:10
      }

    const mouseEnter = () => {
        setIsHover(true);
    };

    const mouseLeave = () => {
        setIsHover(false);
    };
    
    return(
        <div 
            style={Object.assign(wrapper,props.style)} 
            onClick={props.onSelect}
            onMouseEnter={mouseEnter}
            onMouseLeave={mouseLeave}
        >
            <CloseFillIcon id="filterIcon" style={icon} size="32px"></CloseFillIcon>
        </div>

    )
}